module.exports = __webpack_public_path__ + "files/34197c6ad96b991c1405283f57c31f1c.svg";